import React from 'react';
import styles from './Dropdown.module.css'; // Assuming you save the CSS as Dropdown.module.css

function Dropdown({ label, options, value, onChange }) {
  return (
    <div className={styles.dropdown}>
      <label className={styles.label}>{label}</label>
      <select
        className={styles.select}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default Dropdown;
